import { useMetricRamQuery } from "@/common/api/metric/use-metric-ram.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { ScaleIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function GroupMetric() {
  const { t } = useTranslation(["ram", "common"]);
  const { data, isLoading } = useMetricRamQuery();

  return <MetricCard icon={ScaleIcon} label={t("common:Groups")} value={data?.groupCount ?? 0} loading={isLoading} />;
}
